export function getSendTypeDescHelper(sendTypeId: any) {
    var text = "";
    switch (sendTypeId) {
        case 1:
            text = "SMS";
            break;
        case 2:
            text = "E-Mail";
            break;
        case 3:
            text = "E-Mail + SMS";
            break;
        case 4:
            text = "Link";
            break;
        case 5:
            text = "Whatsapp";
            break;
        case 6:
            text = "QR";
            break;
        default:
            break;
    }
    return text;
}